<template>
  <div>
    <v-layout align-center>
      <span class="title">
        Certificates for tickets
      </span>
      <v-spacer/>
      <v-btn
        :disabled="tickets.length === 0"
        icon
        class="ma-0"
        @click="newCertDialog = true">
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
    <v-progress-linear
      v-if="loading || deleting"
      class="ma-0"
      color="grey"
      height="1"
      indeterminate/>
    <v-divider v-else/>
    <template v-if="!loading && tickets.length === 0">
      <v-layout justify-center>
        <span class="subtitle">No ticket defined.</span>
      </v-layout>
    </template>
    <template v-else>
      <v-expansion-panel :value="tickets.length > 0 ? 0 : -1">
        <v-expansion-panel-content>
          <v-expansion-panel expand>
            <v-expansion-panel-content
              v-for="(ticket, i) in tickets"
              :key="ticket.id">
              <div slot="header">
                <v-layout align-center>
                  <v-tooltip
                    v-if="validity[i] === 'check_circle'"
                    left>
                    <v-icon
                      slot="activator"
                      class="green--text text--lighten-3 mr-3">
                      check_circle
                    </v-icon>
                    <span>At least one currently valid certificate</span>
                  </v-tooltip>
                  <v-tooltip
                    v-else-if="validity[i] === 'help'"
                    left>
                    <v-icon
                      slot="activator"
                      class="grey--text mr-3">help</v-icon>
                    <span>No information available</span>
                  </v-tooltip>
                  <v-tooltip
                    v-else-if="validity[i] === 'error'"
                    left>
                    <v-icon
                      slot="activator"
                      class="red--text text--lighten-3 mr-3">error</v-icon>
                    <span>All certificates expired</span>
                  </v-tooltip>
                  <span class="subheading">{{ ticket.name }}</span>
                </v-layout>
              </div>
              <v-card>
                <v-list>
                  <template v-for="(cert, i) in certificates">
                    <v-list-tile
                      v-if="cert.ticketId === ticket.id"
                      :key="i">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <span>{{ cert.dateIssue | formatLLL }}</span>
                          <span><v-icon>chevron_right</v-icon></span>
                          <span>{{ cert.dateExpiry | formatLLL }}</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <span>{{ cert.info }}</span>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-layout align-center>
                          <a :href="cert.link">
                            <v-icon color="blue lighten-3">
                              attachment
                            </v-icon>
                          </a>
                          <v-btn
                            icon
                            class="mx-3"
                            @click="edit(cert)">
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            @click="del(cert)">
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-list-tile-action>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
    <!-- NEW CERT DIALOG -->
    <new-cert-dialog
      v-model="newCertDialog"
      :tickets="tickets"
      :loading="getting"
      @refresh="$emit('refresh')"/>
    <!-- EDIT CERT DIALOG -->
    <edit-cert-dialog
      v-model="editCertDialog"
      :certificate="editedCert"
      :tickets="tickets"
      @refresh="$emit('refresh')"/>
  </div>
</template>

<script>
import moment from "moment";
import EditCertDialog from "./TicketsTable/EditCertDialog";
import NewCertDialog from "./TicketsTable/NewCertDialog";

export default {
  name: "tickets-table",
  components: {
    EditCertDialog,
    NewCertDialog
  },
  props: {
    certificates: {
      type: Array,
      required: true
    },
    loading: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      newCertDialog: false,
      editCertDialog: false,
      editedCert: {
        dateExpiry: null,
        dateIssue: null,
        info: "",
        link: "",
        ticketId: null
      },
      deleting: false,
      tickets: [],
      getting: false
    };
  },
  computed: {
    validity () {
      let arr = Array();
      this.tickets.forEach((t) => {
        let certs = this.certificates.filter((c) => c.ticketId === t.id);
        if (certs.length === 0) {
          arr.push("help");
        } else {
          let now = moment().toISOString();
          let validCerts = certs.filter((c) =>
            (c.dateIssue <= now || c.dateIssue === null) &&
            (c.dateExpiry >= now || c.dateExpiry === null));
          if (validCerts.length > 0) {
            arr.push("check_circle");
          } else {
            arr.push("error");
          }
        }
      });
      return arr;
    }
  },
  created () {
    // Get all the tickets
    this.getting = true;
    this.$http.get("/api/tickets").
      then((r) => {
        this.getting = false;
        this.tickets = Array.from(r.data);
      }).
      catch(() => this.getting = false);
  },
  methods: {
    del (c) {
      this.deleting = true;
      this.$http.
        delete(`/api/franchise_tickets_certs/${c.id}`).
        then(() => {
          this.deleting = false;
          this.$emit("refresh");
        });
    },
    edit (c) {
      this.editedCert = Object.assign({}, c);
      this.editCertDialog = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Franchise/TicketsTable.vue